import { getRouteFeature } from "~/config/pages/localization.config";
import { redirectHomeOnMissing } from "~/helpers/redirect";

export default function (context) {
  const { route, app, $logger } = context;

  // Get brand features from the injected $brand plugin
  const brandFeatures = app.$brand?.features || [];

  // Get the feature requirement for this route
  const routeFeature = getRouteFeature(route.name);

  if (process.server || process.env.NODE_ENV === "development") {
    $logger.debug("[featureFlag] Checking feature flag", {
      routeName: route.name,
      routePath: route.path,
      routeFeature,
      brandFeatures,
      hasFeature: !routeFeature || brandFeatures.includes(routeFeature),
    });
  }

  if (!routeFeature) {
    // No feature flag required for this route
    return;
  }

  if (!brandFeatures.includes(routeFeature)) {
    redirectHomeOnMissing(context);
  }
}
